import script from "./LoginGate.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginGate.vue?vue&type=script&setup=true&lang=js"

import "./LoginGate.vue?vue&type=style&index=0&id=1d6265ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6265ae"]])

export default __exports__